import { useEffect } from "react";
import PropTypes from "prop-types";
import * as Analytics from "../../../services/analyticsUtag";
import styles from "./errorPage.module.scss";
import { useRouter } from "next/router";


const ErrorPage = ({
  statusCode,
  message = "This page could not be found.",
}) => {
    const router = useRouter();
    useEffect(()=>{
        Analytics.view({
            page_name: `${statusCode} error`,
            page_form_event: "error",
            page_errors: `${statusCode}. ${message}`,
            page_error_type: "page",
            page_channel: "shopping",
          });
    },[])
 
  return (
    <>
      <div className={styles.error}>
        <div>
          <h1 className={styles.code}>{statusCode}</h1>
          <div className={styles.wrapper}>
            <h2 className={styles.message}>{message}</h2>
          </div>
        </div>
      </div>
    </>
  );
};
ErrorPage.propTypes = {
  statusCode: PropTypes.number.isRequired,
  message: PropTypes.string,
};
export default ErrorPage;
